import React, { Fragment, useCallback } from "react";
import Button from "./CustomButton";
import { Collapse } from "reactstrap";
import Icon from "@fortawesome/react-fontawesome";
import AddCategoryForm from "./AddCategoryForm";
import useToggle from "./useToggle";

const AddCategoryButton = ({ onCategoryAdded }) => {
  const { isOpen, toggle, hide } = useToggle(false);
  const onSubmitSuccess = useCallback(
    category => {
      hide();
      onCategoryAdded(category);
    },
    [hide, onCategoryAdded]
  );
  return (
    <Fragment>
      <div className="row my-2 my-md-3">
        <div className="col">
          <Button onClick={toggle} color="info" simple>
            Add Category <Icon icon="plus-circle" />
          </Button>
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="row">
          <div className="col">
            <AddCategoryForm onSubmitSuccess={onSubmitSuccess} />
          </div>
        </div>
      </Collapse>
    </Fragment>
  );
};

AddCategoryButton.defaultProps = {
  onCategoryAdded: category => {}
};

export default AddCategoryButton;
